import { useTheme } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { IStylesProps } from '@core/devices/components/DevicesTest/SpeakerTest/interfaces';

export const useStyles = (_props: IStylesProps) => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    playButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: '26px',
      backgroundColor: appTheme?.mainColor,
      padding: '4px 4px 4px 4px',
      width: 'fit-content',
      marginRight: '15px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        borderWidth: 0,
        marginRight: '10px',
        padding: 0,
      },
    },
    playButton: {
      width: '48px',
      height: '48px',
      minWidth: '48px',
      borderRadius: '24px',
      color: colors.white,
      backgroundColor: `color-mix(in srgb, ${appTheme?.mainColor} 80%, black);`,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      position: 'relative',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: `color-mix(in srgb, ${appTheme?.mainColor} 80%, black);`,
      },
      [breakpoints.down(ScreenSizes.Tablet)]: {
        backgroundColor: appTheme?.mainColor,
      },
    },
    playButtonText: {
      margin: '0 10px',
      fontSize: '16px',
      width: '140px',
      color: colors.white,
      textAlign: 'center',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: 'none',
      },
    },
    selectionContainer: {
      width: '100%',
      position: 'relative',
    },
    selection: {
      position: 'absolute',
      content: '""',
      inset: 0,
      padding: '0 8px 0 20px',
      '& .MuiInputBase-root': {
        opacity: 1,
        width: '100%',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '0 2px 0 14px',
        '& .MuiSelect-select p': {
          fontSize: '12px !important',
          lineHeight: '14px',
        },
      },
    },
  };
};
